/* eslint-disable no-use-before-define */
import React from 'react'
import {Fields, compareString, getId} from '../../../twd'
import COUNTIES from './counties.js'
import useMarketNews from '../use-market-news'

const COUNTY_NAMES = COUNTIES
    .reduce( (x,a) => {
        x[a.value] = a.label
        return x
    }, {})

export default ({id}) => {
    const {
        customState,
        customCounty, setCustomCounty,
    } = useMarketNews()
    let id_ = id || getId()
    return <React.Fragment>
        <Fields.Search
            id={id_}
            dataName="municipals-market-news-search-county"
            multiple={false}
            showIcon={false}
            listConfig={{ style:{ minWidth:'200px' } }}
            value={COUNTY_NAMES[customCounty] || ''}
            onSelect={(a) => {
                setCustomCounty(a.value)
            }}
            onClear={() => {
                setCustomCounty('')
            }}
        >{({keyword}) => {
            return <Options keyword={keyword} state={customState}/>
        }}</Fields.Search>
    </React.Fragment>
}

const Options = ({keyword, state}) => {
    const searchResults = getOptions({keyword, state})

    return <React.Fragment>
    {
        searchResults.map( (a,i) => (
            <div
            dataName="municipals-market-news-search-county-option"
            key={i}
            className="auto-suggest-menu-item text-truncate"
            style={{ color:"var(--primary-base-color)" }}
            item={a}
            dangerouslySetInnerHTML={{
                __html: highlightText(a.label, keyword)
            }} />
        ))
    }
    </React.Fragment>
}

const highlightText = (text, keyword) => {
    let s = (''+keyword).trim()
    return s
        ? text.split(s).join(`<b>${s}</b>`)
        : text

}

const getOptions = ({keyword, state}) => {
    let s = (state || '').trim()
    return COUNTIES
        .filter(a => {
            let k = String(keyword).toLowerCase()
            let f = String(a.value).indexOf(k)>=0
                || a.label.toLowerCase().indexOf(k)>=0
            f = f && (!state || a.state===s)
            return f
        })
        .sort( (a,b) => compareString(a.label, b.label))
}


// WEBPACK FOOTER //
// ./src/municipals/market-news/custom-search/search-county.js